import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { FC } from "react";
import { PsychologistServicesSummary } from "src/apis/psychologist";
import { formatDateToBR } from "src/utils/date";

type ServicesByPsychologistSummaryTableProps = {
  summary?: PsychologistServicesSummary | null;
  startDate: string;
  endDate: string;
};

const formatCurrencyBRL = (value?: number | string | null) => {
  const numericValue = Number(value ?? 0);

  return numericValue.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const ServicesByPsychologistSummaryTable: FC<ServicesByPsychologistSummaryTableProps> = ({
  summary,
  startDate,
  endDate,
}) => {
  const nomePsicologo = summary?.nome_psicologo ?? "-";
  const qtdeAtendimentos = summary?.qtde_atendimentos ?? 0;
  const montanteTotalAtendimentos = summary?.montante_total_atendimentos ?? 0;
  const qtdeAcoes = summary?.qtde_acoes ?? 0;
  const montanteTotalAcoes = summary?.montante_total_acoes ?? 0;
  const colaboradoresAtendidos = summary?.colaboradores_atendidos ?? [];

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell colSpan={2}>
              <strong>
                Resumo de atendimentos, período de {formatDateToBR(startDate)} até{" "}
                {formatDateToBR(endDate)}
              </strong>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          <TableRow>
            <TableCell>
              <strong>Psicólogo</strong>
            </TableCell>
            <TableCell>{nomePsicologo}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell>
              <strong>Atendimentos</strong>
            </TableCell>
            <TableCell>{qtdeAtendimentos}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell>
              <strong>Valor Atendimentos</strong>
            </TableCell>
            <TableCell>{formatCurrencyBRL(montanteTotalAtendimentos)}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell>
              <strong>Ações</strong>
            </TableCell>
            <TableCell>{qtdeAcoes}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell>
              <strong>Valor Ações</strong>
            </TableCell>
            <TableCell>{formatCurrencyBRL(montanteTotalAcoes)}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell>
              <strong>Colaboradores atendidos</strong>
            </TableCell>
            <TableCell>
              {colaboradoresAtendidos.length > 0 ? (
                colaboradoresAtendidos.map((nomeColaborador, index) => (
                  <p key={`${nomeColaborador}-${index}`}>{nomeColaborador}</p>
                ))
              ) : (
                "-"
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ServicesByPsychologistSummaryTable;
